import { render, staticRenderFns } from "./PaymentOrderBlockForm.vue?vue&type=template&id=3b9125fa&scoped=true&lang=pug&"
var script = {}
import style0 from "./PaymentOrderBlockForm.vue?vue&type=style&index=0&id=3b9125fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9125fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
